<template>
  <main>
    <div class="container">
      <div class="text">
        <p>Sejam bem-vindos ao</p>
        <h1>Parque das<br />Recordações</h1>
      </div>
      <div class="login">
        <h1>Acesse o portal</h1>
        <form @submit.prevent="logar" class="form" >
          <div class="form-group">
            <label for="text">Login:</label>
            <input
              v-model="user.username"
              type="text"
              id="text"
              autocomplete="username"
              required
            />
          </div>
          <div class="form-group">
            <label for="password">Senha:</label>
            <input
              v-model="user.password"
              type="password"
              id="password"
              autocomplete="current-password"
              required
            />
          </div>
          <div class="form-actions">
            <a href="/forgot-password">Esqueci minha senha</a>
            <button type="submit">Entrar</button>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import { useToast } from "vue-toastification"
const toast = useToast()
export default {
  data(){
    return {
      user: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    logar() {
      if (this.user.username && this.user.password) {
        this.$store.dispatch('auth/login', this.user)
          .then(
            (response) => {
              if (response.status === 200 && response.data.token) {
                this.$router.push('admin/despedidas');
              } else {
                toast.error('Erro ao logar!');
              }
            }
          ).catch(error => {
            if (error.response && error.response.status === 401) {
              toast.error('Usuário ou senha não confere');
            } else {
              toast.error('Falha na conexão com o servidor!');
              console.error(error);
            }
          });
      }
    },
  }
}
</script>


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap");

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Sora", sans-serif;
}

main {
  background-image: url("../../assets/images/Elementos/fundo.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.container {
  min-height: 70vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}

.text {
  color: #343f53;
}

.text p {
  padding-top: 2rem;
  font-size: 31px;
  font-weight: 300;
}

.text h1 {
  font-size: 86px;
  font-weight: 800;
  line-height: 5rem;
}

.login {
  display: flex;
  flex-direction: column;
  background-color: #343f53;
  padding: 1rem 2.6rem;
  border-radius: 9px;
  color: #ffffff;
  align-items: center;
  margin-top: 2rem;
}

.login h1 {
  min-width: 19rem;
  font-size: 37px;
  font-weight: 800;
}

.form-group input {
  margin-top: 0.8rem;
  border: none;
  padding: 0.2rem;
  border-radius: 6px;
  min-width: 14em;
  background-color: #fff;
}

.form-actions {
  text-align: center;
}
.login .form-group {
  display: flex;
  align-items: center;
}

.form-group label {
  margin-right: 0.5rem;
  margin-top: 0.8rem;
  min-width: 5.5rem;
  font-size: 25px;
  font-weight: 300;
}

.login a {
  margin-top: 0.8rem;
  text-decoration: none;
  color: #ffffff;
  font-size: 15px;
  font-weight: 100;
  text-align: center;
  transition: 0.3s;
}

.login button {
  margin-top: 0.8rem;
  padding: 0.2rem 0;
  color: #343f53;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
  width: 80%;
  background-color: #fff;
}

.login button:hover,
.login a:hover {
  opacity: 0.5;
}

@media (max-width: 1037px) {
  .container {
    flex-direction: column;
  }

  .text h1 {
    font-size: 50px;
    line-height: 2.5rem;
  }

  .login {
    padding: 1rem 1rem;
  }

  .login form h1 {
    font-size: 30px;
  }

  .login form input {
    min-width: 12rem;
  }

  .form-group label {
    margin-right: 0.5rem;
    margin-top: 0.8rem;
    min-width: 5rem;
    font-size: 20px;
  }

  .login form a {
    font-size: 14px;
  }

  .login form button {
    margin-top: 0.8rem;
    padding: 0.1rem 0;
    width: 70%;
  }
}
</style>
